import { IconExclamationCircle } from '@tabler/icons-react'
import React from 'react'

interface FullPageErrorProps {
    message?: string
}

const FullPageError: React.FC<FullPageErrorProps> = ({ message = "An error occurred" }) => {
    return (
        <div className='d-flex justify-content-center align-items-center' style={{ height: '100%', minHeight: '100vh' }}>
            <div className='text-center text-danger'>
                <IconExclamationCircle size={72} />
                <p className='mt-3'></p>
                {/* <p className='mt-3'>{message}</p> */}
                {message.split('\n').map((line, index) => (
                    <p key={index}>{line}</p>
                ))}
            </div>
        </div>
    )
}

export default FullPageError